import { render, staticRenderFns } from "./YouTubeRegularTable.vue?vue&type=template&id=0a577e26"
import script from "./YouTubeRegularTable.vue?vue&type=script&lang=js"
export * from "./YouTubeRegularTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports